const ONFIDO_SDK_VERSION = 'v14.43.0';
const ONFIDO_SDK_DOMEN = 'https://sdk.onfido.com/';
export const ONFIDO_DOC_TYPE_VISA = 'residence_permit';
export const ONFIDO_DOC_TYPE_PASSPORT = 'passport';

export const ONFIDO_JS_BUNDLE = `${ONFIDO_SDK_DOMEN}${ONFIDO_SDK_VERSION}`;
